import Dialog from "components/base/Dialog/Dialog";

export default Dialog;
